/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ThemeOptions } from '@mui/material/styles';

declare module '@mui/material/styles' {
	interface BreakpointOverrides {
		xs: true;
		sm: true;
		md: true;
		lg: true;
		xl: true;
		custom: true;
		tablet: true;
	}
}

export const breakpoints: ThemeOptions = {
	breakpoints: {
		values: {
			xs: 320,
			sm: 390,
			md: 800,
			lg: 1200,
			xl: 1360,
			custom: 1025,
			tablet: 960,
		},
	},
};
